module.exports = __webpack_public_path__ + "img/image013.bc666b26.png";